import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "篩檢年份",
    isNumber: true,
    isSum: true,
  },
];

export const AD8TotalScoreToCheckYear = {
  label: "AD8總分 vs 篩檢年份",
  key: "AD8TotalScoreToCheckYear",
  path: "ElderlyHealth/AD8TotalScoreToCheckYear",
  api: "TCS_V_OHCheckItems01V",
  render: (options) => (
    <Diagram.ElderlyHealth.AD8TotalScoreToCheckYear {...options} />
  ),
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "AD8",
      field: "AD8",
      header: "",
      isNumber: true,
      isSkip: true,
    },
  ],
  levelColumns,
  columns: [],
};
